<template>
  <a :href="whatsappLink" target="_blank">
    <slot>
      <AppTooltip>{{ $tt('whatsapp') }}</AppTooltip>
      <AppIcon icon="mdi:whatsapp" color="success" />
    </slot>
  </a>
</template>

<script setup lang="ts">
const { whatsappLink } = useCommunication();
</script>